import React from 'react'
import { FiEdit } from 'react-icons/fi'
import { getTimeAgo } from '../../../_helpers/getTimeAgo'
import { FaRegEye } from 'react-icons/fa'
import Nodata from '../../../components/Atoms/NoData/NoData'
import Pagination from '../../../components/Pagination/Pagination'
import { VscVerified } from 'react-icons/vsc'

const SubMerchantApproved = ({ handleAction, data, size, pageNo, total, onPageChange, count }) => {

    return (
        <div>

            <div className=" space-y-4">
                <div className='mb-6'>
                    <span className='text-[#0F172A] border-b-2 border-[#00811D]  pb-2'>Sub Merchant Approval ({count})</span>
                </div>
                <div className='space-y-3'>

                    {data && data.length > 0 ? data?.map((merchant) => (
                        <div key={merchant.id} >
                            <div className="flex justify-between items-center mb-4 bg-white p-3 border border-[#D2D2D2] rounded-md">
                                <div className="flex items-center gap-1">
                                    <span className="text-[#F6465D] font-medium mr-2">Approve by {`(${merchant?.verifiedBy?.userName} , ${merchant?.verifiedBy?.employeeId} )`}</span>
                                    <div className="flex space-x-2">

                                        <button onClick={() => handleAction("VIEW", merchant)}>
                                            <FaRegEye className="text-[22px] text-blue-500" title='View' />
                                        </button>
                                        <button onClick={() => handleAction("VERIFY", merchant)}>
                                            <VscVerified className="text-[22px] text-blue-500" title='Verify' />
                                        </button>


                                    </div>
                                </div>
                                <div className=" text-[#F6465D]">
                                    {getTimeAgo(merchant?.updatedAt)}
                                </div>
                            </div>
                            <div className="border border-gray-300 rounded-lg  shadow-sm bg-white">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                                    {/* Left Side */}
                                    <div className='space-y-2  md:border-r-2 p-4'>
                                        <img src='/Frame 1707479371 (1).png' className='max-w-[200px] max-h-[52px] w-full  h-auto ' alt='logo' />

                                        <p className='w-full flex justify-between'>
                                            <span>Store Name:</span> {merchant.storeName}
                                        </p>
                                        <p className='w-full flex justify-between'>
                                            <span>Store URL:</span>{" "}
                                            <a href={merchant.storeURL} className="">
                                                {merchant.storeURL}
                                            </a>
                                        </p>
                                        <p className='w-full flex justify-between'>
                                            <span>Charges (%):</span> <span className='flex justify-start items-center gap-2'>{merchant.charges} <FiEdit size={16} /></span>
                                        </p>
                                        <p className='w-full flex justify-between'>
                                            <span>Company Name:</span> {merchant.companyName}
                                        </p>
                                        <p className='w-full flex justify-between'>
                                            <span>Active Sub Stores:</span> {merchant.activeSubStores}
                                        </p>
                                        <p className='w-full flex justify-between'>
                                            <span>Held Time (Days):</span> {merchant.heldTime}
                                        </p>




                                    </div>
                                    <div className=' p-3'>
                                        <div className="flex justify-between items-center mx-auto ">
                                            <div className='flex justify-start items-center gap-2'>
                                                <img src='/img/Group.png' alt='flag' className='w-auto h-auto' />
                                                <span>
                                                    India
                                                </span>

                                            </div>
                                            <span className="text-xs text-gray-500">Board Resolution Letter</span>
                                        </div>
                                        <img src={merchant?.boardResolutionLetter} alt='Electricite' className='max-w-[202px] max-h-[280px] ' />
                                    </div>
                                </div>
                            </div>

                        </div>
                    )) : (
                        <div className='border rounded-md'>
                            <Nodata
                                nodataLabel={"Don't Have Approve Merchant "}
                                nodataDesc={'Add New User here click to below button '}
                                buttonLabel={'+ Add User'}
                            />
                        </div>
                    )}
                </div>



                {Math.ceil(total / size) >
                    1 && (
                        <Pagination
                            totalPages={Math.ceil(
                                total / size
                            )}
                            currentPage={pageNo}
                            onPageChange={onPageChange}
                        />
                    )}

            </div>



        </div>
    )
}

export default SubMerchantApproved